/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./billing-card.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./billing-card.component";
var styles_BillingCardComponent = [i0.styles];
var RenderType_BillingCardComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_BillingCardComponent, data: {} });
export { RenderType_BillingCardComponent as RenderType_BillingCardComponent };
export function View_BillingCardComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵted(0, null, ["", " XXXX-XXXX-XXXX-XXXX-", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.card.brand; var currVal_1 = _co.card.last4; _ck(_v, 0, 0, currVal_0, currVal_1); }); }
export function View_BillingCardComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "dac-billing-card", [], null, null, null, View_BillingCardComponent_0, RenderType_BillingCardComponent)), i1.ɵdid(1, 114688, null, 0, i2.BillingCardComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var BillingCardComponentNgFactory = i1.ɵccf("dac-billing-card", i2.BillingCardComponent, View_BillingCardComponent_Host_0, { card: "card" }, {}, []);
export { BillingCardComponentNgFactory as BillingCardComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/shared/billing-card/billing-card.component.ngfactory.js.pre-build-optimizer.js